import { apiClient } from '@/services/ApiClient.js'

export default {
  getPayments(id) {
    return apiClient
      .get('orders/' + id + '/payments')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getPayment(id, paymentId) {
    return apiClient
      .get('orders/' + id + '/payments/' + paymentId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createPayment(paymentId, collections) {
    return apiClient
      .post('payments/' + paymentId + '/collections', collections)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  startImportFinanceInfoProcess(form) {
    let formData = new FormData()
    formData.append('file', form.file)
    formData.append('notify_farmer', form.notifyFarmerForFinanceInfo)

    return apiClient
      .postForm('/orders/actions/import-finance-info', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  startImportPaymentInfoProcess(form) {
    let formData = new FormData()
    formData.append('file', form.file)
    formData.append('notify_farmer', form.notifyFarmerForPaymentInfo)

    return apiClient
      .postForm('/orders/actions/import-payment-info', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  startImportRetailerPaymentsProcess(form) {
    let formData = new FormData()
    formData.append('file', form.file)
    formData.append('action_date', form.action_date)
    formData.append('notify', form.notify)

    return apiClient
      .postForm('/import-retailer-payments', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  startImportCollectionProcess(form) {
    let formData = new FormData()
    formData.append('file', form.file)

    return apiClient
      .postForm('/orders/actions/import-collections', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  calculateSavingDiscount(paymentId, form) {
    return apiClient
      .post('payments/' + paymentId + '/calculate-saving-discount', form)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  calculateDebt(paymentId, paymentDate) {
    return apiClient
      .post(`payments/${paymentId}/calculate-debt`, {
        payment_date: paymentDate
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  sendLateFeeSms(paymentId, params) {
    return apiClient
      .post(`payments/${paymentId}/send-late-fee-notification`, params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getTransactions(orderId) {
    return apiClient
      .get('orders/' + orderId + '/transactions')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteTransaction(orderId, transactionId, data = {}) {
    return apiClient
      .delete(`orders/${orderId}/transactions/${transactionId}`, { data })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getTransactionCollections(orderId, transactionId) {
    return apiClient
      .get(`orders/${orderId}/transactions/${transactionId}/collections`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
